import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesUnsignedEINChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.numUnsignedEINFields",
		title: "Unsigned EIN Fields",
		yAxisLabel: "Missing Signatures (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.numUnsignedEINFields,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.numUnsignedEINFields );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
